import { useCallback } from "react";

export const useSetMapByGranularity = (codes: string[]) => {
  const setMap = useCallback(
    (data: any) => {
      const values = data.kpiValues.filter((item: any) =>
        codes.includes(item.code),
      );

      const res: any = {};

      [1, 2, 3].forEach((item: number, i: number) => {
        res[item] = values.find((kpi: any) => kpi.code === codes[i])?.value;
      });

      return res;
    },
    [codes],
  );

  return { setMap };
};
